// Resolve an image source. Admin-uploaded images are stored as relative paths
// like "/api/files/..." — prefix them with REACT_APP_BACKEND_URL. Everything else
// (data: URLs, absolute http(s) URLs, static /public assets) is used as-is.
export function mediaUrl(v) {
  if (!v || typeof v !== "string") return v;
  if (v.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${v}`;
  return v;
}
